// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import type { SpDisplayNameUpdateRequest, SpDisplayNameUpdateResponse } from '../../api/types';
import { updateSpDisplayName } from '../../api/portalServices';

export const useUpdateSpDisplayName = (tenantId: string) => {
  return useMutation<SpDisplayNameUpdateResponse, Error, SpDisplayNameUpdateRequest>({
    mutationFn: (data) => updateSpDisplayName(data, tenantId),
  });
};
